import { render, staticRenderFns } from "./frontPorqueElegirnos.vue?vue&type=template&id=588907d9&scoped=true&"
import script from "./frontPorqueElegirnos.vue?vue&type=script&lang=js&"
export * from "./frontPorqueElegirnos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588907d9",
  null
  
)

export default component.exports